import { takeLatest, put } from "redux-saga/effects";
import { FETCH_INVEST_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchInvestSuccess,
  fetchInvestFailure,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchInvest(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/investisseurs`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchInvestSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* investSaga() {
  yield takeLatest(FETCH_INVEST_REQUEST, fetchInvest);
}

export default investSaga;
